import account from './images/account.es.js';
import checklist from './images/checklist.es.js';
import cpu from './images/cpu.es.js';
import promo from './images/promo.es.js';
import search from './images/search.es.js';
import shoppingCart from './images/shopping-cart.es.js';
import freeShipping from './images/free-shipping.es.js';
import close from './images/close.es.js';
import chevronUp from './images/chevron-up.es.js';
import chevronDown from './images/chevron-down.es.js';
import chevronBack from './images/chevron-back.es.js';
import chevronForward from './images/chevron-forward.es.js';
import location from './images/location.es.js';
import addOutline from './images/add-outline.es.js';
import home from './images/home.es.js';
import grid from './images/grid.es.js';
import notifications from './images/notifications.es.js';
import trash from './images/trash.es.js';
import guarantee from './images/guarantee-checked.es.js';
import help from './images/help.es.js';
import product from './images/product.es.js';
import favorite from './images/favorite.es.js';
import flashSale from './images/flash-sale.es.js';
import logoFacebook from './images/logo-facebook.es.js';
import logoYoutube from './images/logo-youtube.es.js';
import logoTiktok from './images/logo-tiktok.es.js';
import logoInstagram from './images/logo-instagram.es.js';
import community from './images/community.es.js';
import call from './images/call.es.js';
import qrCode from './images/qr-code.es.js';
import time from './images/time.es.js';
import card from './images/card.es.js';
import cash from './images/cash.es.js';
import star from './images/star.es.js';
import down from './images/down.es.js';
import up from './images/up.es.js';
import percentage from './images/percentage.es.js';
import tag from './images/tag.es.js';
import circleClose from './images/circle-close.es.js';
import cashColor from './images/cash-color.es.js';
import promotionFill from './images/promotion-fill.es.js';
import plusDefault from './images/plus-default.es.js';
import cashOutline from './images/cash-outline.es.js';
import caution from './images/caution.es.js';
import edit from './images/edit.es.js';
import returnProduct from './images/return-product.es.js';
import freeshippingOutline from './images/freeshipping-outline.es.js';
import freeshippingColor from './images/freeshipping-color.es.js';
import success from './images/success.es.js';
import setting from './images/setting.es.js';
import laptop from './images/laptop.es.js';
import voucher from './images/shape.es.js';
import logoGoogle from './images/logo-google.es.js';
import timeOutline from './images/time-outline.es.js';
import trendingUpOutline from './images/trending-up-outline.es.js';
import promotion from './images/promotion.es.js';
import menu from './images/menu.es.js';
import arrowDown from './images/arrow_down.es.js';
import photo from './images/photo.es.js';
import excel from './images/excel.es.js';
import messenger from './images/messenger-logo.es.js';
import pdf from './images/pdf.es.js';
import tick from './images/tick.es.js';
import error from './images/error.es.js';
import bell from './images/bell.es.js';
import buildpc from './images/buildpc.es.js';
import envelope from './images/envelope.es.js';
import showroom from './images/showroom.es.js';
import support from './images/support.es.js';
import warranty from './images/warranty.es.js';
import journalist from './images/journalist.es.js';
import chat from './images/chat.es.js';
import cpuIcon from './images/cpu-icon.es.js';
import motherBoard from './images/mother-board-icon.es.js';
import ram from './images/RAM-icon.es.js';
import hdd from './images/hard-disk-icon.es.js';
import ssd from './images/ssd-disk-icon.es.js';
import vga from './images/grphics-card-icon.es.js';
import power from './images/power-icon.es.js';
import chassis from './images/chassis-icon.es.js';
import heatSink from './images/heat-sink-icon.es.js';
import monitor from './images/monitor-icon.es.js';
import keyboard from './images/keyboard-icon.es.js';
import mouse from './images/mouse-icon.es.js';
import gift from './images/gift.es.js';
import dino from './images/dino.es.js';
import dinoIcon from './images/dino-icon.es.js';
import moreInfo from './images/more-info.es.js';
import gridLayout from './images/grid-layout.es.js';
import listLayout from './images/list-layout.es.js';
import filter from './images/filter.es.js';
import filterSortBy from './images/filter-sort-by.es.js';
import check from './images/check.es.js';
import news from './images/news.es.js';
import upload from './images/upload.es.js';
import caretDown from './images/caret-down.es.js';
import more from './images/more.es.js';
import clock from './images/clock.es.js';
import checkbox from './images/checkbox.es.js';
import plus from './images/plus.es.js';
import subtract from './images/subtract.es.js';
import bag_checkmark from './images/bag_checkmark.es.js';
import download from './images/download.es.js';
import logout from './images/logout.es.js';
import calendar from './images/calendar.es.js';
import phone from './images/phone.es.js';
import businessPerson from './images/business-person.es.js';
import plusCircle from './images/Plus-circle.es.js';
import letter from './images/letter.es.js';
import returnVnd from './images/return-vnd.es.js';
import reportSold from './images/report-sold.es.js';
import sellOut from './images/sellout.es.js';
import reports from './images/reports.es.js';
import minus from './images/minus.es.js';
import refresh from './images/refresh.es.js';
import voucherCash from './images/voucher-cash.es.js';
import loyalty from './images/loyalty.es.js';
import zalo from './images/zalo.es.js';
import share from './images/share.es.js';
import email from './images/email.es.js';
import logoZalo from './images/logo-zalo.es.js';
import linkedin from './images/linkedin.es.js';
import idCart from './images/id-card.es.js';

const iconMap = {
  account,
  checklist,
  cpu,
  promo,
  search,
  "shopping-cart": shoppingCart,
  "free-shipping": freeShipping,
  close,
  "chevron-up": chevronUp,
  "chevron-down": chevronDown,
  location,
  "add-outline": addOutline,
  "chevron-back": chevronBack,
  "chevron-forward": chevronForward,
  home,
  grid,
  notifications,
  trash,
  guarantee,
  help,
  product,
  favorite,
  "flash-sale": flashSale,
  "logo-facebook": logoFacebook,
  "logo-youtube": logoYoutube,
  community,
  call,
  "qr-code": qrCode,
  time,
  card,
  cash,
  star,
  down,
  up,
  percentage,
  tag,
  "circle-close": circleClose,
  "cash-color": cashColor,
  "promotion-fill": promotionFill,
  "plus-default": plusDefault,
  "cash-outline": cashOutline,
  caution,
  edit,
  "return-product": returnProduct,
  "freeshipping-outline": freeshippingOutline,
  "freeshipping-color": freeshippingColor,
  success,
  setting,
  laptop,
  voucher,
  "logo-google": logoGoogle,
  "time-outline": timeOutline,
  "trending-up-outline": trendingUpOutline,
  promotion,
  menu,
  photo,
  excel,
  "arrow-down": arrowDown,
  messenger,
  pdf,
  tick,
  error,
  bell,
  buildpc,
  envelope,
  showroom,
  support,
  warranty,
  journalist,
  chat,
  "cpu-icon": cpuIcon,
  "mother-board": motherBoard,
  ram,
  hdd,
  ssd,
  vga,
  power,
  chassis,
  "heat-sink": heatSink,
  monitor,
  keyboard,
  mouse,
  gift,
  dino,
  "dino-icon": dinoIcon,
  more,
  "more-info": moreInfo,
  "grid-layout": gridLayout,
  "list-layout": listLayout,
  filter,
  "filter-sort-by": filterSortBy,
  check,
  news,
  "caret-down": caretDown,
  upload,
  clock,
  checkbox,
  plus,
  subtract,
  "bag-checkmark": bag_checkmark,
  download,
  logout,
  calendar,
  phone,
  "business-person": businessPerson,
  "plus-circle": plusCircle,
  letter,
  "return-vnd": returnVnd,
  "report-sold": reportSold,
  sellout: sellOut,
  reports,
  minus,
  refresh,
  "voucher-cash": voucherCash,
  loyalty,
  zalo,
  share,
  "logo-tiktok": logoTiktok,
  "logo-instagram": logoInstagram,
  email,
  "logo-zalo": logoZalo,
  linkedin,
  "id-card": idCart
};
const icons = Object.keys(iconMap);

export { iconMap, icons };
